<template>
  <div class="trafficAnalysis">
    <div class="centerStructure">
      <section>
        <div class="item firstItem">
          <div class="center">
            <h1 class="h1">PV</h1>
            <div class="fontbox">
              <ul>
                <li>
                  <span>今日浏览量</span>
                  <span class="font20">{{ pvObj.today }}</span>
                </li>
                <li>
                  <span>昨日浏览量</span>
                  <span class="font20">{{ pvObj.yesterday }}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>本月浏览量</span>
                  <span class="font20">{{ pvObj.month }}</span>
                </li>
                <li>
                  <span>本年浏览量</span>
                  <span class="font20">{{ pvObj.year }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item firstItem">
          <div class="center">
            <h1 class="h2">UV</h1>
            <div class="fontbox">
              <ul>
                <li>
                  <span>今日用户数</span>
                  <span class="font20">{{ uvObj.today }}</span>
                </li>
                <li>
                  <span>昨日用户数</span>
                  <span class="font20">{{ uvObj.yesterday }}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>本月用户数</span>
                  <span class="font20">{{ uvObj.month }}</span>
                </li>
                <li>
                  <span>本年用户数</span>
                  <span class="font20">{{ uvObj.year }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item firstItem">
          <div class="center">
            <h1 class="h3">IP</h1>
            <div class="fontbox">
              <ul>
                <li>
                  <span>今日IP数</span>
                  <span class="font20">{{ ipObj.today }}</span>
                </li>
                <li>
                  <span>昨日IP数</span>
                  <span class="font20">{{ ipObj.yesterday }}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>本月IP数</span>
                  <span class="font20">{{ ipObj.month }}</span>
                </li>
                <li>
                  <span>本年IP数</span>
                  <span class="font20">{{ ipObj.year }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item firstItem">
          <div class="center">
            <h1 class="h4">客户</h1>
            <div class="fontbox">
              <ul>
                <li>
                  <span>今日访问量</span>
                  <span class="font20">{{ userObj.today }}</span>
                </li>
                <li>
                  <span>昨日访问量</span>
                  <span class="font20">{{ userObj.yesterday }}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>本月访问量</span>
                  <span class="font20">{{ userObj.month }}</span>
                </li>
                <li>
                  <span>本年访问量</span>
                  <span class="font20">{{ userObj.year }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="item thirdItem">
          <div class="lintit"><i></i><span>近30日访问流量统计</span></div>
          <div class="barBox" id="traffic1"></div>
        </div>
        <div class="item thirdItem">
          <div class="lintit"><i></i><span>业务访问频率统计</span></div>
          <ul class="button-groups">
            <li :class="[actIdx1===index?'active':'']" v-for="(item,index) in btnArr1" :key="item"
                @click="jmDailyChange($event,index)">{{ item }}
            </li>
          </ul>
          <div class="barBox" id="traffic2"></div>
        </div>
      </section>
      <section>
        <div class="item wholerow">
          <div class="lintit"><i></i><span>客户活跃度统计</span></div>
          <ul class="button-groups">
            <li :class="[actIdx2===index?'active':'']" v-for="(item,index) in btnArr2" :key="item"
                @click="fjmDailyChange($event,index)">{{ item }}
            </li>
          </ul>
          <div class="barBox" id="traffic3"></div>
        </div>
      </section>
      <section>
        <div class="item thirdItem">
          <div class="lintit"><i></i><span>分辨率TOP10排名</span></div>
          <div class="barBox" id="traffic4"></div>
        </div>
        <div class="item thirdItem">
          <div class="lintit"><i></i><span>操作系统占比</span></div>
          <div class="barBox" id="traffic5"></div>
        </div>
      </section>
    </div>
    <el-dialog
        :title="title1"
        :visible.sync="openFlag"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="1200px">
      <div class="item">
        <div class="alertChart" id="traffic6"></div>
      </div>
    </el-dialog>
    <el-dialog
        :title="title2"
        :visible.sync="openFlag1"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="1200px">
      <div class="item">
        <div class="alertChart" id="traffic7"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/pie');
require('echarts/lib/chart/line');
require('echarts/lib/chart/bar');
require('echarts/lib/component/grid');
require('echarts/lib/chart/gauge');
require('echarts/lib/component/legend');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/dataZoom');
require('echarts/lib/component/title');
require('zrender/lib/svg/svg');
import echartsThemeSet from "@/config/echartsTheme/echartsTheme.js"
import {mapGetters} from 'vuex'
import {$http} from '@/config/api/axios'
import {Mixins} from '@/config/mixins/mixins'

export default {
  name: 'trafficAnalysis',
  mixins: [Mixins],
  data() {
    return {
      pvObj: {},
      uvObj: {},
      ipObj: {},
      userObj: {},
      btnArr1: ['TOP30', 'LAST30'],
      btnArr2: ['TOP50', 'LAST50'],
      openFlag: false,
      openFlag1: false,
      title1: '',
      title2: '',
      actIdx1: 0,
      actIdx2: 0,
      echartsTheme: localStorage.getItem('echartsTheme'),
      myChartsObj: {
        traffic1: {
          instance: '',
          id: 'traffic1',
          option: {
            dataZoom: {type: "inside"},
            tooltip: {trigger: 'axis', transitionDuration: 0},
            grid: {
              top: '20%',
              bottom: '20%',
              left: '4%',
              right: '2%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: [],
            },
            yAxis: [{
              type: 'value',
              name: '点击量(次)',
              axisLabel: {
                formatter: function (item) {
                  if (item >= 10000) {
                    let i = item / 10000;
                    return `${i}万`;
                  } else {
                    return item;
                  }
                }
              }
            }],
            legend: {
              data: ['PV', 'UV']
            },
            series: [
              {
                name: 'PV',
                type: 'bar',
                barMaxWidth: 70,
                barGap: 0,
                data: []
              },
              {
                name: 'UV',
                type: 'bar',
                barMaxWidth: 70,
                data: []
              },
            ]
          }
        },
        traffic2: {
          instance: '',
          id: 'traffic2',
          option: {
            dataZoom: {type: "inside"},
            tooltip: {
              trigger: 'axis',
              transitionDuration: 0,
              formatter: function (params) {
                return (
                    `${params[0].name.substring(0, params[0].name.indexOf('&'))}<br/>
                                        ${params[0].marker}&nbsp;${params[0].seriesName}&emsp;${params[0].value}<br/>
                                        `
                )
              }
            },
            grid: {
              top: '20%',
              bottom: '20%',
              left: '5%',
              right: '6%',
              containLabel: false,
            },
            xAxis: {
              triggerEvent: true,
              type: 'category',
              data: [],
              axisLabel: {
                rotate: -45,
                formatter: function (value) {
                  if (value.indexOf('&') > -1) {
                    let index = value.indexOf('&');
                    return value.substring(0, index)
                  }
                }
              }
            },
            yAxis: [{
              type: 'value',
              name: '点击量(次)',
              axisLabel: {
                formatter: function (item) {
                  if (item >= 10000) {
                    let i = item / 10000;
                    return `${i}万`;
                  } else {
                    return item;
                  }
                }
              }
            }],
            series: [
              {
                name: '访问频率',
                type: 'bar',
                barMaxWidth: 70,
                data: [],
                itemStyle: {
                  normal: {
                    color: "#edafda"
                  }
                }
              },
            ]
          }
        },
        traffic3: {
          instance: '',
          id: 'traffic3',
          option: {
            dataZoom: {type: "inside"},
            tooltip: {
              trigger: 'axis',
              transitionDuration: 0,
              formatter: function (params) {
                return (
                    `${params[0].name.substring(0, params[0].name.indexOf('&'))}<br/>
                                        ${params[0].marker}&nbsp;${params[0].seriesName}&emsp;${params[0].value}<br/>
                                        ${params[1].marker}&nbsp;${params[1].seriesName}&emsp;${params[1].value}`
                )
              }
            },
            grid: {
              top: '20%',
              bottom: '25%',
              left: '5%',
              right: '6%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: [],
              triggerEvent: true,
              axisLabel: {
                rotate: -45,
                formatter: function (value) {
                  if (value.indexOf('&') > -1) {
                    let index = value.indexOf('&');
                    return value.substring(0, index)
                  }
                }
              }
            },
            yAxis: [{
              type: 'value',
              name: '点击量(次)',
              axisLabel: {
                formatter: function (item) {
                  if (item >= 10000) {
                    let i = item / 10000;
                    return `${i}万`;
                  } else {
                    return item;
                  }
                }
              }
            }],
            legend: {
              data: ['PV', 'UV']
            },
            series: [
              {
                name: 'PV',
                type: 'bar',
                barMaxWidth: 70,
                barGap: 0,
                data: [],
                itemStyle: {
                  normal: {
                    color: "#2ec7c9"
                  }
                }
              },
              {
                name: 'UV',
                type: 'bar',
                barMaxWidth: 70,
                data: [],
                itemStyle: {
                  normal: {
                    color: "#ffb980"
                  }
                }
              },
            ]
          }
        },
        traffic4: {
          instance: '',
          id: 'traffic4',
          option: {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              top: "7%",
              left: '3%',
              right: '4%',
              bottom: '10%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: []
            },
            series: [{
              name: '分辨率统计',
              type: 'bar',
              data: [],
              label: {
                show: true,
                position: "right"
              }
            }]
          }
        },
        traffic5: {
          instance: '',
          id: 'traffic5',
          option: {
            tooltip: {
              trigger: 'item'
            },
            series: [
              {
                name: '操作系统',
                type: 'pie',
                radius: '80%',
                data: [],
                label: {
                  formatter: '{b}\n{d}%',
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 17,
                  rich: {
                    time: {
                      fontSize: 10,
                      color: '#999'
                    }
                  }
                },
              }
            ]
          }
        }
      },
      dialogCharts: {
        traffic6: {
          instance: '',
          id: 'traffic6',
          option: {
            title: {
              text: '访问频率',
              left: 'center'
            },
            dataZoom: {type: "inside"},
            tooltip: {
              trigger: 'axis',
              transitionDuration: 0,
              formatter: function (params) {
                return (
                    `${params[0].name.substring(0, params[0].name.indexOf('&'))}<br/>
                                        ${params[0].marker}&nbsp;${params[0].seriesName}&emsp;${params[0].value}<br/>
                                        `
                )
              }
            },
            grid: {
              top: '20%',
              bottom: '20%',
              left: '5%',
              right: '6%',
              containLabel: false,
            },
            xAxis: {
              triggerEvent: true,
              type: 'category',
              data: [],
              axisLabel: {
                rotate: -45,
                formatter: function (value) {
                  if (value.indexOf('&') > -1) {
                    let index = value.indexOf('&');
                    return value.substring(0, index)
                  }
                }
              }
            },
            yAxis: [{
              type: 'value',
              name: '点击量(次)',
              axisLabel: {
                formatter: function (item) {
                  if (item >= 10000) {
                    let i = item / 10000;
                    return `${i}万`;
                  } else {
                    return item;
                  }
                }
              }
            }],
            series: [
              {
                name: '访问频率',
                type: 'bar',
                barMaxWidth: 70,
                data: [],
                itemStyle: {
                  normal: {
                    color: "#edafda"
                  }
                }
              },
            ]
          }
        },
        traffic7: {
          instance: '',
          id: 'traffic7',
          option: {
            title: {
              text: '客户活跃度',
              left: 'center'
            },
            dataZoom: {type: "inside"},
            tooltip: {
              trigger: 'axis',
              transitionDuration: 0,
              formatter: function (params) {
                return (
                    `${params[0].name.substring(0, params[0].name.indexOf('&'))}<br/>
                                        ${params[0].marker}&nbsp;${params[0].seriesName}&emsp;${params[0].value}<br/>
                                        ${params[1].marker}&nbsp;${params[1].seriesName}&emsp;${params[1].value}`
                )
              }
            },
            grid: {
              top: '20%',
              bottom: '20%',
              left: '5%',
              right: '6%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: [],
              triggerEvent: true,
              axisLabel: {
                rotate: -45,
                formatter: function (value) {
                  if (value.indexOf('&') > -1) {
                    let index = value.indexOf('&');
                    return value.substring(0, index)
                  }
                }
              }
            },
            yAxis: [{
              type: 'value',
              name: '点击量(次)',
              axisLabel: {
                formatter: function (item) {
                  if (item >= 10000) {
                    let i = item / 10000;
                    return `${i}万`;
                  } else {
                    return item;
                  }
                }
              }
            }],
            legend: {
              top: '8%',
              data: ['PV', 'UV']
            },
            series: [
              {
                name: 'PV',
                type: 'bar',
                barMaxWidth: 70,
                barGap: 0,
                data: [],
                itemStyle: {
                  normal: {
                    color: "#2ec7c9"
                  }
                }
              },
              {
                name: 'UV',
                type: 'bar',
                barMaxWidth: 70,
                data: [7, 6, 5, 4, 3, 1],
                itemStyle: {
                  normal: {
                    color: "#ffb980"
                  }
                }
              },
            ]
          }
        },
      },
      resizeYH: {}, // 缓存图表resize
      apiLoading1: true,
      apiLoading2: true,
      apiLoading3: true,
      apiLoading4: true,
      apiLoading5: true,
      apiLoading6: true,
    }
  },
  computed: {
    ...mapGetters('Home', [
      'globalTheme',
    ]),
    loadingShow() {
      let flag;
      if (this.apiLoading1 && this.apiLoading2 && this.apiLoading3 && this.apiLoading4 && this.apiLoading5 && this.apiLoading6) {
        flag = 'hide';
      } else {
        flag = 'show';
      }
      return flag;
    }
  },
  watch: {
    globalTheme(val) {
      if (this.echartsTheme !== this.globalTheme) { //切换至当前组件时，如果主题已经变化，重新初始化主题色
        this.myChartsObj = echartsThemeSet(this.myChartsObj);
        this.echartsTheme = this.globalTheme;
        this.changeAlertChart()
      }
    },
    loadingShow(loading) {
      loading === 'show' ? this.selfLoadingOpen('.trafficAnalysis') : this.selfLoadingClose();
    }
  },
  methods: {
    changeAlertChart() {
      if (!!this.dialogCharts.traffic6.instance) {
        this.dialogCharts['traffic6'].instance.dispose();
        this.dialogCharts['traffic6'].instance = echarts.init(document.getElementById('traffic6'), this.echartsTheme);
        this.dialogCharts['traffic6'].instance.setOption(this.dialogCharts['traffic6'].option);
      }
      if (!!this.dialogCharts.traffic7.instance) {
        this.dialogCharts['traffic7'].instance.dispose();
        this.dialogCharts['traffic7'].instance = echarts.init(document.getElementById('traffic7'), this.echartsTheme);
        this.dialogCharts['traffic7'].instance.setOption(this.dialogCharts['traffic7'].option);
      }
    },
    jmDailyChange(e, index) {
      switch (index) {
        case 0:
          this.getTraffic2('DESC')
          break;
        case 1:
          this.getTraffic2('ESC')
          break;
      }
      let tg = e.target;
      let tgp = e.target.parentElement;
      let lists = Array.from(tgp.querySelectorAll('li'));
      this.actIdx1 = lists.indexOf(tg);
    },
    fjmDailyChange(e, index) {
      switch (index) {
        case 0:
          this.getTraffic3('DESC')
          break;
        case 1:
          this.getTraffic3('ESC')
          break;
      }
      let tg = e.target;
      let tgp = e.target.parentElement;
      let lists = Array.from(tgp.querySelectorAll('li'));
      this.actIdx2 = lists.indexOf(tg);
    },

    setThrityDays() {
      let aXisData = [];
      for (let i = 30; i > 0; i--) {
        let today = new Date()
        let prevDay = today.getTime() - 1000 * 3600 * 24 * i;
        today.setTime(prevDay);
        let month = today.getMonth() + 1;
        let day = today.getDate();
        aXisData.push(month + '月' + day + '日')
      }
      return aXisData;
    },
    getFirstData() {
      this.apiLoading1 = false
      $http('get', "visitStatistics/getBaseData").then((res) => {
        this.apiLoading1 = true
        if (res.status === "SUCCESS") {
          if (!!res.data) {
            this.pvObj = res.data.pvList[0];
            this.uvObj = res.data.uvList[0];
            this.ipObj = res.data.ipList[0];
            this.userObj = res.data.customerList[0];

          }
        } else {
          this.msgerror(res.message);
        }
      })
    },
    getTraffic1() {
      this.apiLoading2 = false
      $http('get', "visitStatistics/getVisitTrafficStatistics").then((res) => {
        this.apiLoading2 = true
        let option1 = this.myChartsObj.traffic1.option;
        if (res.status === "SUCCESS") {
          if (!!res.data && res.data.length > 0) {
            option1.series[0].data = new Array(30).fill('--');
            option1.series[1].data = new Array(30).fill('--');
            option1.xAxis.data = this.setThrityDays();
            res.data.forEach((item) => {
              if (item.date.indexOf('0') === 0) {
                item.date = item.date.substring(1)
              }
              let index = this.setThrityDays().findIndex((ele) => ele == item.date); // 找到日期对应索引
              this.myChartsObj.traffic1.option.series[0].data[index] = item.pvCount;
              this.myChartsObj.traffic1.option.series[1].data[index] = item.uvCount;
            })
            this.myChartsObj.traffic1.instance.setOption(this.myChartsObj.traffic1.option);
          }
        } else {
          if (res.status === "NORESOURCES") {
            this.myChartsObj.traffic1.option.xAxis.data = [];
            this.myChartsObj.traffic1.option.series[0].data = [];
            this.myChartsObj.traffic1.option.series[1].data = [];
          } else {
            this.msgerror(res.message);
          }
        }
      })
    },
    getTraffic2(orderCode = 'DESC', customerId = '') {
      let params = {orderCode, customerId};
      this.apiLoading3 = false
      $http('get', "visitStatistics/getBusinessVisitFrequencyStatistics", params).then((res) => {
        this.apiLoading3 = true
        let option2 = this.myChartsObj.traffic2.option;
        let option6 = this.dialogCharts.traffic6.option;
        if (res.status === "SUCCESS") {
          if (!!res.data && res.data.length > 0) {
            if (!!customerId) { // 弹框的
              option6.xAxis.data = [];
              option6.series[0].data = [];
              res.data.forEach((item) => {
                option6.xAxis.data.push(item.moduleName + '&' + item.moduleId)
                option6.series[0].data.push(item.count)
              })
              this.dialogCharts.traffic6.instance.setOption(option6);
            } else {
              option2.xAxis.data = [];
              option2.series[0].data = [];
              res.data.forEach((item) => {
                option2.xAxis.data.push(item.moduleName + '&' + item.moduleId)
                option2.series[0].data.push(item.count)
              })
              this.myChartsObj.traffic2.instance.setOption(option2);
              this.myChartsObj.traffic2.instance.off('click');
              this.myChartsObj.traffic2.instance.on('click', 'xAxis.category', (chartEv) => {
                let idx = chartEv.value.indexOf('&');
                let id = chartEv.value.substring(idx + 1)
                this.title2 = chartEv.value.substring(0, idx)
                this.openEchart(2) // 打开弹窗
                this.getTraffic3('DESC', id)
              })
            }
          } else {
            option6.xAxis.data = [];
            option6.series[0].data = [];
            this.dialogCharts.traffic6.instance.setOption(option6);
          }
        } else {
          if (res.status === "NORESOURCES") {
            if (!!customerId) {
              option6.xAxis.data = [];
              option6.series[0].data = [];
              this.dialogCharts.traffic6.instance.setOption(option6);
            } else {
              option2.xAxis.data = [];
              option2.series[0].data = [];
              this.myChartsObj.traffic2.instance.setOption(option2);
            }
          } else {
            this.msgerror(res.message);
          }
        }
      })
    },
    getTraffic3(orderCode = 'DESC', moduleId = '') {
      let params = {orderCode, moduleId};
      this.apiLoading4 = false
      $http('get', "visitStatistics/getCustomerActivityStatistics", params).then((res) => {
        this.apiLoading4 = true
        let option3 = this.myChartsObj.traffic3.option;
        let option7 = this.dialogCharts.traffic7.option;
        if (res.status === "SUCCESS") {
          if (!!res.data && res.data.length > 0) {
            if (!!moduleId) {
              option7.xAxis.data = [];
              option7.series[0].data = [];
              option7.series[1].data = [];
              res.data.forEach((item) => {
                option7.xAxis.data.push(item.customerName + '&' + item.customerId)
                option7.series[0].data.push(item.pvCount)
                option7.series[1].data.push(item.uvCount)
              })
              this.dialogCharts.traffic7.instance.setOption(option7);
            } else {
              option3.xAxis.data = [];
              option3.series[0].data = [];
              option3.series[1].data = [];
              res.data.forEach((item) => {
                option3.xAxis.data.push(item.customerName + '&' + item.customerId)
                option3.series[0].data.push(item.pvCount)
                option3.series[1].data.push(item.uvCount)
              })
              this.myChartsObj.traffic3.instance.setOption(option3);
              this.myChartsObj.traffic3.instance.off('click');
              this.myChartsObj.traffic3.instance.on('click', 'xAxis.category', (chartEv) => {
                let idx = chartEv.value.indexOf('&');
                let id = chartEv.value.substring(idx + 1)
                this.title1 = chartEv.value.substring(0, idx)
                this.openEchart(1) // 打开弹窗
                this.getTraffic2('DESC', id)
              })
            }
          } else {
            option7.xAxis.data = [];
            option7.series[0].data = [];
            option7.series[1].data = [];
            this.dialogCharts.traffic7.instance.setOption(option7);
          }
        } else {
          if (res.status === "NORESOURCES") {
            if (!!moduleId) {
              option7.xAxis.data = [];
              option7.series[0].data = [];
              option7.series[1].data = [];
              this.dialogCharts.traffic7.instance.setOption(option7);
            } else {
              option3.xAxis.data = [];
              option3.series[0].data = [];
              option3.series[1].data = [];
              this.myChartsObj.traffic3.instance.setOption(option3);
            }
          } else {
            this.msgerror(res.message);
          }
        }
      })
    },
    getTraffic4() {
      this.apiLoading5 = false
      $http('get', "visitStatistics/getResolutionRanking").then((res) => {
        this.apiLoading5 = true
        let option4 = this.myChartsObj.traffic4.option;
        if (res.status === "SUCCESS") {
          if (!!res.data && res.data.length > 0) {
            res.data.forEach((item) => {
              option4.yAxis.data.unshift(item.resolution)
              option4.series[0].data.unshift(item.count)
            })
          }
          this.myChartsObj.traffic4.instance.setOption(option4)
        } else {
          if (res.status === "NORESOURCES") {
            this.myChartsObj.traffic4.option.xAxis.data = [];
            this.myChartsObj.traffic4.option.series[0].data = [];
          } else {
            this.msgerror(res.message);

          }
        }
      })
    },
    getTraffic5() {
      this.apiLoading6 = false
      $http('get', "visitStatistics/getOperatingSystemRatio").then((res) => {
        this.apiLoading6 = true
        let option5 = this.myChartsObj.traffic5.option;
        if (res.status === "SUCCESS") {
          if (!!res.data && res.data.length > 0) {
            res.data.forEach((item) => {
              if (!!item.opsSystem) {
                option5.series[0].data.push({value: item.count, name: item.opsSystem})
              }
            })
          }
          this.myChartsObj.traffic5.instance.setOption(option5)
        } else {
          if (res.status === "NORESOURCES") {
            this.myChartsObj.traffic5.option.series[0].data = [];
          } else {
            this.msgerror(res.message);
          }
        }
      })
    },
    openEchart(type) {
      if (type == 1) {
        this.openFlag = true;
      } else {
        this.openFlag1 = true;
      }
      this.$nextTick(() => {
        if (type == 1) {
          if (this.dialogCharts['traffic6'].instance === '') {
            this.dialogCharts['traffic6'].instance = echarts.init(document.getElementById('traffic6'), this.echartsTheme);
            this.dialogCharts['traffic6'].instance.setOption(this.dialogCharts['traffic6'].option)
          }
        } else {
          if (this.dialogCharts['traffic7'].instance === '') {
            this.dialogCharts['traffic7'].instance = echarts.init(document.getElementById('traffic7'), this.echartsTheme);
            this.dialogCharts['traffic7'].instance.setOption(this.dialogCharts['traffic7'].option)
          }
        }

        return
        Object.keys(this.dialogCharts).forEach(key => {
          this.initDialogCharts(key);
        })
      })
    },
    initDialogCharts(id) {
      if (this.dialogCharts[id].instance === '') {
        this.dialogCharts[id].instance = echarts.init(document.getElementById(id), this.echartsTheme);
        this.dialogCharts[id].instance.setOption(this.dialogCharts[id].option)
      }
    },
    initEcharts(id) {
      this.myChartsObj[id].instance = echarts.init(document.getElementById(id), this.echartsTheme);
      this.resizeYH[id] = this.debounce(this.myChartsObj[id].instance.resize);
    },
    bindResize() {
      window.addEventListener("resize", () => {
        if (this.$route.path.includes('/trafficAnalysis')) {
          this.resizeYH['traffic1']();
          this.resizeYH['traffic2']();
          this.resizeYH['traffic3']();
          this.resizeYH['traffic4']();
          this.resizeYH['traffic5']();
        }
      });
    },
  },
  created() {
    this.getFirstData()
    this.$nextTick(() => {
      Object.keys(this.myChartsObj).forEach(key => {
        this.initEcharts(key)
      })
      this.bindResize();
      this.getTraffic1();
      this.getTraffic2();
      this.getTraffic3();
      this.getTraffic4();
      this.getTraffic5();
    })
  },
  activated() {
    this.$nextTick(() => {
      this.resizeYH['traffic1']();
      this.resizeYH['traffic2']();
      this.resizeYH['traffic3']();
      this.resizeYH['traffic4']();
      this.resizeYH['traffic5']();
    })
    if (this.echartsTheme !== this.globalTheme) { //切换至当前组件时，如果主题已经变化，重新初始化主题色
      this.myChartsObj = echartsThemeSet(this.myChartsObj);
      this.echartsTheme = this.globalTheme;
      this.changeAlertChart()
    }
  }
}
</script>

<style lang="less">
.trafficAnalysis {
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;

  .centerStructure {
    padding: 0;
    overflow: auto;
    background: #f6f4fc !important;
    box-shadow: none;

    section {
      display: flex;
      margin-bottom: 10px;

      &:last-child {
        margin: 0;
      }

      .item {
        border-radius: 4px;
        box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
        margin-right: 10px;
        background: #fff;

        &:last-child {
          margin: 0px;
        }
      }

      .firstItem {
        flex: 1;
        height: 165px;
        display: flex;

        .center {
          margin: auto;
          margin-top: 20px;

          h1 {
            font-size: 20px;
          }

          .h1 {
            color: #a29afb;
          }

          .h2 {
            color: #5ab1ef;
          }

          .h3 {
            color: #edafda;
          }

          .h4 {
            color: #2ec7c9;
          }

          ul {
            li {
              span {
                line-height: 40px;
                font-size: 16px;
              }

              span.font20 {
                margin-left: 10px;
                font-size: 20px;
                font-weight: bold;
                vertical-align: -2px;
              }
            }

            &:first-child {
              margin-right: 40px;
            }
          }

          .fontbox {
            display: flex;
          }
        }
      }

      .thirdItem {
        flex: 1;
        min-height: 323px;
        height: calc(100vh - 613px);
        padding: 20px;
      }

      .wholerow {
        flex: 1;
        height: 323px;
        padding: 20px;
      }

      .lintit {
        margin: 0;
      }

      .button-groups {
        float: right;
        position: relative;
        z-index: 9;
      }

      .barBox {
        width: 100%;
        height: 270px;

        > div {
          &:first-child {
            width: 100% !important;
          }
        }
      }
    }
  }

  .alertChart {
    width: 100%;
    height: 500px;
  }

  .ft16 {
    font-size: 16px;
  }

  .marB5 {
    margin-bottom: 5px;
  }
}
</style>
